const exitPopup = `
  <div class="ExitPopup__body">
    <div class="ExitPopup__heading">Grab <span class="underlined underlined--blue">a discount!</span></div>
    <div class="ExitPopup__description">Get <strong>20% off</strong> your first order with the coupon SAVE20NOW</div>
    <a data-banner-btn href="/dashboard/orders/create/?couponCode=SAVE20NOW" class="btn btn--black">use coupon</a>
    <span class="btn btn-close">No, Thanks</span>
  </div>`;

export default exitPopup;
